var map = {
	"./lonely-astronaut-cover.jpg": "sTEH",
	"./lonely-astronaut.mp4": "O0vH",
	"./module1-cover.jpg": "ikv7",
	"./module1-female.mp4": "7KnL",
	"./module1-male.mp4": "bGXg",
	"./module1_spanish.mp4": "ndSI",
	"./module1b-female.mp4": "EhcX",
	"./module1b-male.mp4": "A4JE",
	"./module1b_spanish.mp4": "oOtz",
	"./module3-cover.jpg": "n3LL",
	"./module3-female.mp4": "2EIv",
	"./module3-male.mp4": "PG6q",
	"./module3_spanish.mp4": "iGbO",
	"./module4-cover.jpg": "LkeZ",
	"./module4-female.mp4": "JG5K",
	"./module4-male.mp4": "SA4Q",
	"./module4_spanish.mp4": "za5a",
	"./module5-cover.jpg": "re15",
	"./module5-female.mp4": "1BoC",
	"./module5-male.mp4": "M9yq",
	"./module5_spanish.mp4": "YlMr",
	"./module6-cover.jpg": "IVeL",
	"./module6-female.mp4": "UfNS",
	"./module6-male.mp4": "M18M",
	"./module6_spanish.mp4": "mEBl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "X9qF";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video ^\.\/.*$
// module id = X9qF
// module chunks = 0